import { render, staticRenderFns } from "./BoostModule.vue?vue&type=template&id=323403d0&scoped=true&lang=pug&"
import script from "./BoostModule.vue?vue&type=script&lang=js&"
export * from "./BoostModule.vue?vue&type=script&lang=js&"
import style0 from "./BoostModule.vue?vue&type=style&index=0&id=323403d0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323403d0",
  null
  
)

export default component.exports